import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import signalsPlugin from '@backstage/plugin-signals/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import techdocsMermaidModule from 'backstage-plugin-techdocs-addon-mermaid/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import rbacPlugin from '@backstage-community/plugin-rbac';
import gitlabPlugin from '@immobiliarelabs/backstage-plugin-gitlab/alpha';
import azureDevOpsPlugin from '@backstage-community/plugin-azure-devops/alpha';
import n8nPlugin from '@backstage-community/plugin-n8n/alpha';
import authPlugin from '@backstage/plugin-auth';
import { litellmPlugin } from '@acarmisc/backstage-plugin-litellm';
import { aiConversationPlugin } from '@acarmisc/backstage-plugin-ai-conversation';
import abbyMemoryPlugin from '@abstract/plugin-abby-memory';
import { aiAgentsPlugin } from '@acarmisc/backstage-plugin-ai-agents';
import { navModule } from './modules/nav';
import { richardAdminFeature } from './modules/richardAdmin';
import { themeModule } from './modules/theme';
import { appModuleSignIn } from './modules/appModuleSignIn';
import homePlugin from './modules/home';
import techInsightsPlugin from '@backstage-community/plugin-tech-insights/alpha';
import sonarQubePlugin from '@backstage-community/plugin-sonarqube/alpha';
import announcementsPlugin from '@backstage-community/plugin-announcements/alpha';

export default createApp({
  features: [
    catalogPlugin,
    catalogImportPlugin,
    scaffolderPlugin,
    apiDocsPlugin,
    userSettingsPlugin,
    catalogGraphPlugin,
    orgPlugin,
    signalsPlugin,
    notificationsPlugin,
    kubernetesPlugin,
    techdocsPlugin,
    techdocsMermaidModule,
    searchPlugin,
    rbacPlugin,
    gitlabPlugin,
    azureDevOpsPlugin,
    n8nPlugin,
    sonarQubePlugin,
    authPlugin,
    litellmPlugin,
    aiConversationPlugin,
    aiAgentsPlugin,
    abbyMemoryPlugin,
    richardAdminFeature,
    navModule,
    themeModule,
    appModuleSignIn,
    homePlugin,
    techInsightsPlugin,
    announcementsPlugin,
  ],
});
